export const H_YM = '{y}-{m}'
export const H_YM_ABBR = '{y}{m}'

export const H_DATE = '{y}-{m}-{d}'
export const H_DATE_ABBR = '{y}{m}{d}'

export const H_MH = '{y}-{m}-01'

export const H_DATETIME = '{y}-{m}-{d} {h}:{i}:{s}'
export const H_DATETIME_ABBR = '{y}{m}{d}{h}{i}{s}'

export const H_H_I = '{h}:{i}'
export const H_M_D_H_I = '{m}-{d} {h}:{i}'
export const H_Y_M_D_H_I = '{y}-{m}-{d} {h}:{i}'

export const T_YM = 'YYYY-MM'
export const T_YM_ABBR = 'YYYYMM'
export const T_DATE = 'YYYY-MM-DD'
export const T_DATE_ABBR = 'YYYYMMDD'
export const T_MH = 'YYYY-MM-01'
export const T_DATETIME = 'YYYY-MM-DD HH:mm:ss'
export const T_DATETIME_ABBR = 'YYYYMMDDHHmmss'
export const T_H_I = 'HH:mm'
export const T_M_D_H_I = 'MM-DD HH:mm'
export const T_Y_M_D_H_I = 'YYYY-MM-DD HH:mm'
